import SpriteSymbol from "../../../../node_modules/.store/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/.store/svg-sprite-loader@5.2.1/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-suoxiao_",
  "use": "icon-suoxiao_-usage",
  "viewBox": "0 0 1026 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1026 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-suoxiao_\"><path d=\"M996.13 872.379L752.715 628.964a408.61 408.61 0 10-123.75 123.75L872.38 996.13a87.56 87.56 0 10123.75-123.75zM225.025 471.942a58.373 58.373 0 110-116.746h367.75a58.373 58.373 0 010 116.746z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol